import { useDispatch } from 'react-redux';
import { DebugToggle } from '../internal.models';
import Toggle, { ToggleSize } from 'common/components/inputs/toggle';
import { onDebugToggleChanged } from '../internal-settings.slice';

export interface DebugToggleActionProps {
  debugToggle: DebugToggle;
}

export default function DebugToggleAction({
  debugToggle
}: DebugToggleActionProps) {
  const dispatch = useDispatch();

  return (
    <>
      <Toggle
        checked={debugToggle.enabled}
        label=""
        identifier={debugToggle.name}
        size={ToggleSize.Large}
        onChange={() => dispatch(onDebugToggleChanged(debugToggle))}
      ></Toggle>
    </>
  );
}
